// extracted by mini-css-extract-plugin
module.exports = {"CustomTextInput":"CustomTextInput_CustomTextInput__ZTTUG","variableButton":"CustomTextInput_variableButton__igDE_"};